import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import CitySearchSelect from '../../../global/CitySearchSelect';

const defaultForm = {
    name: '',
    city_id: '',
    city: '',
    address: '',
    email: '',
    phone: '',
    website: '',
    description: '',
};

const ManufacturerVenueCreateModal = ({ show, onClose, onSubmit, submitting }) => {
    const { t } = useTranslation();
    const [form, setForm] = useState(defaultForm);
    const [errors, setErrors] = useState({});

    useEffect(() => {
        if (show) {
            setForm(defaultForm);
            setErrors({});
        }
    }, [show]);

    if (!show) {
        return null;
    }

    const handleChange = (event) => {
        const { name, value } = event.target;
        setForm((prev) => ({ ...prev, [name]: value }));
    };

    const handleSubmit = (event) => {
        event.preventDefault();
        if (!form.name.trim()) {
            setErrors({ name: t('ManufacturerVenues.create.errors.nameRequired') });
            return;
        }
        setErrors({});
        onSubmit(form);
    };

    return (
        <Overlay>
            <Modal>
                <Header>
                    <Title>{t('ManufacturerVenues.create.title')}</Title>
                </Header>
                <form onSubmit={handleSubmit}>
                    <Body>
                        <Field>
                            <label>{t('ManufacturerVenues.create.fields.name')}</label>
                            <input name="name" value={form.name} onChange={handleChange} required />
                            {errors.name && <ErrorText>{errors.name}</ErrorText>}
                        </Field>
                        <Field>
                            <label>{t('ManufacturerVenues.create.fields.city')}</label>
                            <CitySearchSelect
                                cityId={form.city_id || null}
                                value={form.city}
                                placeholder={t('ManufacturerVenues.create.fields.city')}
                                onChange={(city) =>
                                    setForm((prev) => ({
                                        ...prev,
                                        city: city?.name || '',
                                        city_id: city?.id || '',
                                    }))
                                }
                            />
                        </Field>
                        <Field>
                            <label>{t('ManufacturerVenues.create.fields.address')}</label>
                            <input name="address" value={form.address} onChange={handleChange} />
                        </Field>
                        <Field>
                            <label>{t('ManufacturerVenues.create.fields.email')}</label>
                            <input type="email" name="email" value={form.email} onChange={handleChange} />
                        </Field>
                        <Field>
                            <label>{t('ManufacturerVenues.create.fields.phone')}</label>
                            <input name="phone" value={form.phone} onChange={handleChange} />
                        </Field>
                        <Field>
                            <label>{t('ManufacturerVenues.create.fields.website')}</label>
                            <input name="website" value={form.website} onChange={handleChange} />
                        </Field>
                        <Field>
                            <label>{t('ManufacturerVenues.create.fields.description')}</label>
                            <textarea name="description" value={form.description} onChange={handleChange} rows={3} />
                        </Field>
                    </Body>
                    <Footer>
                        <Button type="button" onClick={onClose} disabled={submitting}>
                            {t('ManufacturerVenues.create.cancel')}
                        </Button>
                        <PrimaryButton type="submit" disabled={submitting}>
                            {submitting ? t('ManufacturerVenues.create.saving') : t('ManufacturerVenues.create.save')}
                        </PrimaryButton>
                    </Footer>
                </form>
            </Modal>
        </Overlay>
    );
};

export default ManufacturerVenueCreateModal;

const Overlay = styled.div`
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.4);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 999;
`;

const Modal = styled.div`
    background: #fff;
    border-radius: 12px;
    width: 520px;
    max-width: 90%;
    box-shadow: 0 12px 30px rgba(0, 0, 0, 0.15);
`;

const Header = styled.div`
    padding: 1.25rem;
    border-bottom: 1px solid rgba(130, 22, 146, 0.1);
`;

const Title = styled.h3`
    margin: 0;
`;

const Body = styled.div`
    padding: 1.25rem;
    display: flex;
    flex-direction: column;
    gap: 1rem;
`;

const Field = styled.div`
    display: flex;
    flex-direction: column;
    gap: 0.375rem;

    input, textarea {
        border: 1px solid rgba(130, 22, 146, 0.2);
        border-radius: 8px;
        padding: 0.625rem;
        font-size: 1rem;
    }
`;

const Footer = styled.div`
    padding: 1.25rem;
    display: flex;
    justify-content: flex-end;
    gap: 0.75rem;
    border-top: 1px solid rgba(130, 22, 146, 0.1);
`;

const Button = styled.button`
    padding: 0.625rem 1.125rem;
    background: transparent;
    border: 1px solid rgba(130, 22, 146, 0.3);
    border-radius: 8px;
    cursor: pointer;
`;

const PrimaryButton = styled(Button)`
    background: rgba(130, 22, 146, 1);
    color: #fff;
    border-color: rgba(130, 22, 146, 1);
`;

const ErrorText = styled.span`
    color: #d32f2f;
    font-size: 0.875rem;
`;
